module.exports = __webpack_public_path__ + "static/media/sun-dust.cd38861f.svg";